<!-- EXT-6424: the Edit/Track/Receipt cell contents, shared by their own
columns and by the compact layout's single Actions column. -->
<ng-template #editAction let-order>
  @if (order.claimable) {
    <!-- EXT-6551: another store's potential order on an event this dealer
    joined; claiming opens it in Order Entry. -->
    <button type="button" class="claim-order-button" (click)="claimOrder(order)">
      Claim
    </button>
  } @else if (!order.subrental) {
    @if (this.loadingOrderId !== order.internalOrderNumber) {
      <mat-icon class="edit-icon" (click)="redirectToEdit(order)"
        >edit_document</mat-icon
      >
    } @else {
      <div
        style="
          min-width: 100%;
          display: flex;
          flex-direction: row;
          justify-content: center;
        "
      >
        <mat-spinner diameter="15"></mat-spinner>
      </div>
    }
  }
</ng-template>
<ng-template #trackAction let-order>
  @if (orderHasShippingStatus(order.details)) {
    <mat-icon class="edit-icon" (click)="openModal(order)"
      >local_shipping</mat-icon
    >
  } @else {}
</ng-template>
<ng-template #receiptAction let-order>
  <!-- EXT-6551: a claimable order is still the event owner's; its receipt
  isn't the claiming store's to open. -->
  @if (!order.subrental && !order.claimable) {
    <mat-icon
      [ngClass]="setReceiptClass(order)"
      class="edit-icon"
      (click)="redirectToReceipt(order)"
      >receipt</mat-icon
    >
  }
</ng-template>

<div class="container">
  @if (
    loaded() && !error() && localOrderList() && localOrderList()!.length > 0
  ) {
    <table
      mat-table
      [dataSource]="visibleOrderList() || []"
      class="mat-elevation-z8"
      [class.newsite]="showNewDesign"
      [class.compact]="compact"
      [class.shows-account]="showsOtherAccounts()"
    >
      <ng-container matColumnDef="internalOrderNumber">
        <th class="table-header" mat-header-cell *matHeaderCellDef>Edit</th>
        <td class="table-cell" mat-cell *matCellDef="let order">
          <ng-container
            *ngTemplateOutlet="editAction; context: { $implicit: order }"
          ></ng-container>
        </td>
      </ng-container>

      <ng-container matColumnDef="tracking">
        <th class="table-header" mat-header-cell *matHeaderCellDef>Track</th>
        <td class="table-cell" mat-cell *matCellDef="let order">
          <ng-container
            *ngTemplateOutlet="trackAction; context: { $implicit: order }"
          ></ng-container>
        </td>
      </ng-container>

      <ng-container matColumnDef="receipt">
        <th class="table-header" mat-header-cell *matHeaderCellDef>Receipt</th>
        <td class="table-cell" mat-cell *matCellDef="let order">
          <ng-container
            *ngTemplateOutlet="receiptAction; context: { $implicit: order }"
          ></ng-container>
        </td>
      </ng-container>

      <ng-container matColumnDef="eventDate">
        <th
          class="table-header"
          mat-header-cell
          *matHeaderCellDef
          [class.sorted]="sortKey() === 'eventDate'"
          (click)="sortBy('eventDate')"
        >
          Date
          @if (sortKey() === "eventDate") {
            <span class="sort-arrow">{{ sortDirection() === 1 ? "↑" : "↓" }}</span>
          }
        </th>
        <td class="table-cell" mat-cell *matCellDef="let order">
          {{ order.eventDate | date: "MM/dd/yy" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="orderNumber">
        <th
          class="table-header"
          mat-header-cell
          *matHeaderCellDef
          [class.sorted]="sortKey() === 'orderNumber'"
          (click)="sortBy('orderNumber')"
        >
          #
          @if (sortKey() === "orderNumber") {
            <span class="sort-arrow">{{ sortDirection() === 1 ? "↑" : "↓" }}</span>
          }
        </th>
        <td class="table-cell" mat-cell *matCellDef="let order">
          @if (!order.subrental) {
            {{ order.orderNumber }}
            <!-- EXT-6596: an order on another account than the one loaded. -->
            @if (otherAccountOf(order); as account) {
              <span
                class="other-account-tag"
                [title]="'This order is on account ' + account"
                >{{ account }}</span
              >
            }
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="customer">
        <th
          class="table-header"
          mat-header-cell
          *matHeaderCellDef
          [class.sorted]="sortKey() === 'customer'"
          (click)="sortBy('customer')"
        >
          Customer
          @if (sortKey() === "customer") {
            <span class="sort-arrow">{{ sortDirection() === 1 ? "↑" : "↓" }}</span>
          }
        </th>

        <td class="table-cell" mat-cell *matCellDef="let order; let i = index">
          @for (seg of highlightSegments(order.fullName, filterTerm()); track $index) {
            @if (seg.match) {
              <mark>{{ seg.text }}</mark>
            } @else {
              {{ seg.text }}
            }
          }
          <div class="condition-badges">
            @if (hasReplacement(order)) {
              <!-- matTooltip="{{ getReplacementToolTip(order) }}" -->
              <app-custom-tooltip
                [tooltipText]="getReplacementToolTip(order)"
                position="bottom"
                backgroundColor="var(--surface-tooltip, #f6f6f6)"
                textColor="var(--text-body, #000000)"
                minWidth="200px"
              >
                <div class="hover-info-text">Replacement</div>
              </app-custom-tooltip>
            }
            @if (hasDirectDelivery(order)) {
              <app-custom-tooltip
                [tooltipText]="getDirectDelieveryToolTip(order)"
                position="bottom"
                backgroundColor="var(--surface-tooltip, #f6f6f6)"
                textColor="var(--text-body, #000000)"
                minWidth="250px"
                textAlign="center"
              >
                <div class="hover-info-text">Direct Delivery</div>
              </app-custom-tooltip>
            }
            @if (order.subrental) {
              <p class="subrental">
                Subrental {{ order.warehouseOrderHeader }}
              </p>
            }
            @if (!order.subrental && order.shipToCode === 2) {
              <app-custom-tooltip
                [tooltipText]="getShipToDiffActToolTip(order)"
                position="bottom"
                backgroundColor="var(--surface-tooltip, #f6f6f6)"
                textColor="var(--text-body, #000000)"
                minWidth="250px"
                textAlign="center"
              >
                <p class="subrental">Ship To Diff Acct</p>
              </app-custom-tooltip>
            }
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="eventDescription">
        <th
          class="table-header"
          mat-header-cell
          *matHeaderCellDef
          [class.sorted]="sortKey() === 'eventDescription'"
          (click)="sortBy('eventDescription')"
        >
          Event
          @if (sortKey() === "eventDescription") {
            <span class="sort-arrow">{{ sortDirection() === 1 ? "↑" : "↓" }}</span>
          }
        </th>
        <td class="table-cell" mat-cell *matCellDef="let order">
          @if (
            this.loadingEventId === order.nationalEventId &&
            order.internalOrderNumber === this.loadingOrderNumber
          ) {
            <div
              style="
                min-width: 100%;
                display: flex;
                flex-direction: row;
                justify-content: center;
              "
            >
              <mat-spinner diameter="15"></mat-spinner>
            </div>
          } @else {
            <a (click)="this.redirectToEventManager(order)">
              @for (seg of highlightSegments(order.eventDescription, filterTerm()); track $index) {
                @if (seg.match) {
                  <mark>{{ seg.text }}</mark>
                } @else {
                  {{ seg.text }}
                }
              }
            </a>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="orderType">
        <th
          class="table-header"
          mat-header-cell
          *matHeaderCellDef
          [class.sorted]="sortKey() === 'orderType'"
          (click)="sortBy('orderType')"
        >
          Type
          @if (sortKey() === "orderType") {
            <span class="sort-arrow">{{ sortDirection() === 1 ? "↑" : "↓" }}</span>
          }
        </th>
        <td class="table-cell" mat-cell *matCellDef="let order">
          {{ order.orderType }}
        </td>
      </ng-container>

      <ng-container matColumnDef="orderStatus">
        <th
          class="table-header"
          mat-header-cell
          *matHeaderCellDef
          [class.sorted]="sortKey() === 'orderStatus'"
          (click)="sortBy('orderStatus')"
        >
          Status
          @if (sortKey() === "orderStatus") {
            <span class="sort-arrow">{{ sortDirection() === 1 ? "↑" : "↓" }}</span>
          }
        </th>
        <td class="table-cell" mat-cell *matCellDef="let order">
          <!-- {{ order.orderStatus }} -->

          @if (getOrderStatus(order) === "Not Checked In") {
            <app-custom-tooltip
              [tooltipText]="getOrderStatusToolTip(order)"
              position="bottom"
              backgroundColor="var(--surface-tooltip, #f6f6f6)"
              textColor="var(--text-body, #000000)"
              minWidth="200px"
            >
              <a class="warn" (click)="this.openModal(order)">
                {{ getOrderStatus(order) }}
              </a>
            </app-custom-tooltip>
          } @else {
            <a
              (click)="this.openModal(order)"
              [ngClass]="
                getOrderStatus(order) === order.orderStatus ? '' : 'warn'
              "
            >
              {{ getOrderStatus(order) }}
            </a>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="coat">
        <th class="table-header" mat-header-cell *matHeaderCellDef>Coat</th>
        <td class="table-cell" mat-cell *matCellDef="let order">
          @if (showNewDesign) {
            <div class="garment-cell">
              <div>{{ splitStyleSize(getCoatInfo(order.details)[0]).style }}</div>
              <div class="garment-size">{{ splitStyleSize(getCoatInfo(order.details)[0]).size }}</div>
            </div>
          } @else {
            <div class="sub-column-2">
              @for (
                detail of getCoatInfo(order.details)[0].trim().split(" ");
                track detail
              ) {
                <div class="detail-item">{{ detail }}</div>
              }
            </div>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="pant">
        <th class="table-header" mat-header-cell *matHeaderCellDef>Pant</th>
        <td class="table-cell" mat-cell *matCellDef="let order">
          @if (showNewDesign) {
            <div class="garment-cell">
              <div>{{ splitStyleSize(getPantInfo(order.details)[0]).style }}</div>
              <div class="garment-size">{{ splitStyleSize(getPantInfo(order.details)[0]).size }}</div>
            </div>
          } @else {
            <div class="sub-column-3">
              @for (
                detail of getPantInfo(order.details)[0].trim().split(" ");
                track detail
              ) {
                <div class="detail-item">{{ detail }}</div>
              }
            </div>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="shirt">
        <th class="table-header" mat-header-cell *matHeaderCellDef>Shirt</th>
        <td class="table-cell" mat-cell *matCellDef="let order">
          @if (showNewDesign) {
            <div class="garment-cell">
              <div>{{ splitStyleSize(getShirtInfo(order.details)[0]).style }}</div>
              <div class="garment-size">{{ splitStyleSize(getShirtInfo(order.details)[0]).size }}</div>
            </div>
          } @else {
            <div class="sub-column-3">
              @for (
                detail of getShirtInfo(order.details)[0].trim().split(" ");
                track detail
              ) {
                <div class="detail-item">{{ detail }}</div>
              }
            </div>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="tie">
        <th class="table-header" mat-header-cell *matHeaderCellDef>Tie</th>
        <td class="table-cell" mat-cell *matCellDef="let order">
          @if (showNewDesign) {
            <div class="garment-cell">
              <div>{{ splitStyleSize(getTieInfo(order.details)[0]).style }}</div>
              <div class="garment-size">{{ splitStyleSize(getTieInfo(order.details)[0]).size }}</div>
            </div>
          } @else {
            <div class="sub-column-2">
              @for (
                detail of getTieInfo(order.details)[0].trim().split(" ");
                track detail
              ) {
                <div class="detail-item">{{ detail }}</div>
              }
            </div>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="vest">
        <th class="table-header" mat-header-cell *matHeaderCellDef>Vest</th>
        <td class="table-cell" mat-cell *matCellDef="let order">
          @if (showNewDesign) {
            <div class="garment-cell">
              <div>{{ splitStyleSize(getVestInfo(order.details)[0]).style }}</div>
              <div class="garment-size">{{ splitStyleSize(getVestInfo(order.details)[0]).size }}</div>
            </div>
          } @else {
            <div class="sub-column-2">
              @for (
                detail of getVestInfo(order.details)[0].trim().split(" ");
                track detail
              ) {
                <div class="detail-item">{{ detail }}</div>
              }
            </div>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="shoe">
        <th class="table-header" mat-header-cell *matHeaderCellDef>Shoe</th>
        <td class="table-cell" mat-cell *matCellDef="let order">
          @if (showNewDesign) {
            <div class="garment-cell">
              <div>{{ splitStyleSize(getShoeInfo(order.details)[0]).style }}</div>
              <div class="garment-size">{{ splitStyleSize(getShoeInfo(order.details)[0]).size }}</div>
            </div>
          } @else {
            <div class="sub-column-2">
              @for (
                detail of getShoeInfo(order.details)[0].trim().split(" ");
                track detail
              ) {
                <div class="detail-item">{{ detail }}</div>
              }
            </div>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="pocket">
        <th class="table-header" mat-header-cell *matHeaderCellDef>Pkt</th>
        <td class="table-cell" mat-cell *matCellDef="let order">
          {{ getPocketInfo(order.details)[0] }}
        </td>
      </ng-container>

      <ng-container matColumnDef="jewelry">
        <th class="table-header" mat-header-cell *matHeaderCellDef>Jewl</th>
        <td class="table-cell" mat-cell *matCellDef="let order">
          {{ getJewelryInfo(order.details || [])[0] }}
        </td>
      </ng-container>

      <!-- EXT-6424: compact-layout columns (see compactBelow). -->
      <ng-container matColumnDef="actions">
        <th class="table-header" mat-header-cell *matHeaderCellDef>Actions</th>
        <td class="table-cell" mat-cell *matCellDef="let order">
          <div class="action-icons">
            <span class="action-slot">
              <ng-container
                *ngTemplateOutlet="editAction; context: { $implicit: order }"
              ></ng-container>
            </span>
            <span class="action-slot">
              <ng-container
                *ngTemplateOutlet="trackAction; context: { $implicit: order }"
              ></ng-container>
            </span>
            <span class="action-slot">
              <ng-container
                *ngTemplateOutlet="receiptAction; context: { $implicit: order }"
              ></ng-container>
            </span>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="garments">
        <th class="table-header" mat-header-cell *matHeaderCellDef>Garments</th>
        <td class="table-cell" mat-cell *matCellDef="let order">
          <div class="garment-list">
            @for (garment of garmentSummary(order.details); track garment.label) {
              <span class="garment-chip">
                <span class="garment-label">{{ garment.label }}</span>
                {{ garment.style }}
                @if (garment.size) {
                  <span class="garment-size">{{ garment.size }}</span>
                }
              </span>
            }
          </div>
        </td>
      </ng-container>
      <!-- ======================================================================= -->

      <ng-container matColumnDef="nationalEventId">
        <th class="table-header" mat-header-cell *matHeaderCellDef>
          National Event Id
        </th>
        <td class="table-cell" mat-cell *matCellDef="let order">
          {{ order.nationalEventId }}
        </td>
      </ng-container>

      <ng-container matColumnDef="productionWeek">
        <th class="table-header" mat-header-cell *matHeaderCellDef>PWeek</th>
        <td class="table-cell" mat-cell *matCellDef="let order">
          {{ order.productionWeek }}
        </td>
      </ng-container>

      <ng-container matColumnDef="eventAccount">
        <th class="table-header" mat-header-cell *matHeaderCellDef>
          Event Account
        </th>
        <td class="table-cell" mat-cell *matCellDef="let order">
          {{ order.eventAccount }}
        </td>
      </ng-container>

      <tr
        class="table-header-row"
        [class.sticky-header]="stickyHeaderStackAbove()"
        [jfwStickyStackTop]="stickyHeaderStackAbove()"
        mat-header-row
        *matHeaderRowDef="visibleColumns"
      ></tr>
      <tr
        class="default-row"
        [ngClass]="{ 'alt-row': i % 2 === 1 }"
        mat-row
        *matRowDef="let row; let i = index; columns: visibleColumns"
      ></tr>
    </table>

    <div class="pagination-footer">
      @if (hasMore()) {
        <button
          type="button"
          class="load-more-button"
          (click)="loadMore()"
        >
          Load 50 more
        </button>
      }
      <span class="end-label">{{ endLabel() }}</span>
    </div>
  } @else if (
    loaded() &&
    !error() &&
    receivedOrderList !== undefined &&
    receivedOrderList.length === 0
  ) {
    <div>No orders found</div>
  } @else if (error()) {
    <!-- <mat-error>Error loading orders</mat-error> -->
  }
</div>
